import { ComponentPropsWithoutRef, forwardRef } from 'react'
import styled from 'styled-components'
import { GreyGrey60, IconEdit } from '@sequencehq/core-components'

export const SummaryRowEditButton = forwardRef<
  HTMLButtonElement,
  ComponentPropsWithoutRef<'button'>
>((props, ref) => (
  <StyledButton ref={ref} type="button" {...props}>
    <IconEdit />
  </StyledButton>
))

const StyledButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 16px;
  height: 16px;
  background: none;
  border: none;
  color: ${GreyGrey60};
  cursor: pointer;
  visibility: hidden;

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  [role='group']:hover & {
    visibility: visible;
  }
`
